import CategorySelector from './src/main';

/* istanbul ignore next */
CategorySelector.install = function(Vue) {
  Vue.component(CategorySelector.name, CategorySelector);
};

export default CategorySelector;
